import { BigHeading, PageLayout } from "@components/ui/PageLayout"
import { useRoutePageContext } from "@components/ui/route-page-context"
import WorkDetails from "@components/work/WorkDetails"
import { workPageQueryOptions } from "@data/public-page-data-query"
import * as m from "@paraglide/messages"
import type { WorkPageData } from "@site-types/public-page-data"
import { createFileRoute, redirect } from "@tanstack/react-router"
import { isSupportedLocale } from "@utils/locale"
import { localizedRouteHead } from "@utils/route-head"

export const Route = createFileRoute("/$locale/work")({
  beforeLoad: ({ params }) => {
    if (!isSupportedLocale(params.locale)) throw redirect({ to: "/404" })
  },
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(workPageQueryOptions(params.locale as "en" | "ja")),
  head: ({ params }) => {
    const locale = params.locale as "en" | "ja"
    return localizedRouteHead({ locale, page: "work", path: `/${locale}/work` })
  },
  component: RouteComponent,
})

function RouteComponent() {
  const data = Route.useLoaderData()
  return (
    <PageLayout>
      <WorkPage data={data} />
    </PageLayout>
  )
}

export function WorkPage({ data }: { data: WorkPageData }) {
  const { locale } = useRoutePageContext()

  return (
    <>
      <BigHeading variant="h1">
        {(m.work_heading_label({}, { locale: locale }) || "Our Work").toUpperCase()}
      </BigHeading>
      <WorkDetails data={data} />
    </>
  )
}
